//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'TheYamaguchiDiagnosticCriteriaofAdultonsetStill',
  data () {
    return {
      form: {
        data1: '0',
        data2: '0',
        data3: '0',
        data4: '0',
        data5: '0',
        data6: '0',
        data7: '0',
        data8: '0',
        data9: '0',
        data10: '0',
        data11: '0'
      },
      hasScore: false,
      disabled: false
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad'])
  },
  computed: {
    /** 计算公式结果 */
    score () {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          form[key] = Number(form[key])
        }
      }
      let result1 = form.data1 + form.data2 + form.data3 + form.data4
      let result2 = form.data5 + form.data6 + form.data7 + form.data8
      let result3 = form.data9 + form.data10 + form.data11

      if (result1 >= 2 && (result1 + result2 >= 5) && result3 === 0) {
        return 'Still 病（AOSD）'
      } else {
        return ''
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/formulas/RI/TheYamaguchiDiagnosticCriteriaofAdultonsetStill.vue